import React from 'react'
import {Link} from "react-router-dom";
import User from "../../../models/User";
import TalentAppStep from "../components/TalentAppStep";

export default class ReviewStep extends TalentAppStep {


    static path = '/review';
    /**
     * The title shown on the form
     */
    static StepTitle = TB.trans('talent.review.step_title');
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = 'Please review your profile below and when ready, submit your application.';
    /**
     * The start page info tile
     */
    static StepInfo = null //TB.trans('talent.review.step_info');

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        return !user.validateReview() ? this : false;
    };

    static getPath(prefix = '/talent/application') {
        return `${prefix}${this.path}`
    }

    /**
     * Hide completion icon on sidebar
     */
    static NeedsCompletion = () => false;

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {

        if (!user.hasCompletedApplication()) {
            TB.toast("Please finish all required steps before submitting", {theme: "danger"});
            return false;
        }

        return {
            applied_at: (new Date()).toISOString()
        }
    };

    static hasCompleted(user) {
        return user.hasCompletedApplication();
    }

    /**
     * The fields mapping for the form
     */
    static showFormButtons() {
        return true
    }

    reviewStep(step) {
        let props = step.reviewMapping(this.props.user, this.props.authUser);
        let reviewElements = [];
        for (let [prop, value] of Object.entries(props)) {
            let valueElement = <div/>;
            if (TB.isObject(value) && !Array.isArray(value)) {

                valueElement = [];
                for (let [subLabel, subProp] of Object.entries(value)) {
                    valueElement.push((
                        <div className="review-sub-container" key={`user-${prop}-${subLabel}-${valueElement?.length + 1}`}>
                            <p className="review-sub-label">{subLabel}</p>
                            {TB.isString(subProp) ? (
                                <p className="review-sub-prop">{subProp}</p>
                            ) : (
                                <div className="review-sub-prop">{subProp}</div>
                            )}
                        </div>
                    ))
                }
            } else if (Array.isArray(value) && !TB.find(value, val => TB.isString(val))) {
                valueElement = <div key={`review-${prop}`} className="review-prop">{value}</div>
            } else {
                valueElement = <p key={`review-${prop}`} className="review-prop">{value}</p>
            }

            reviewElements.push((
                <div key={`user-${prop}`} className="review-prop-container">
                    <p className="review-label text-lg font-semibold">{prop}</p>
                    {valueElement}
                </div>
            ))
        }

        return reviewElements;
    }


    /**
     * Render the form
     *
     * @returns {Form}
     */
    render() {
        let steps = TB.filter([...this.props.user.getApplicationStepsForTalent()], step => step.StepInfo && !step.HideReview);

        // mimics isAdminEditing in file @TalentApplication.js
        const isAdminEditing = this.context.auth.canManageClientResourceTalent() && !!this.props.user;

        return (
            <div className="talent-application" style={{marginRight: 'auto', marginLeft: 'auto'}}>
                {this.renderTitle()}

                <div className="talent-role-form">

                    <div className="wripple-form">
                        <div className="form-container items-stretch">

                            {steps.map((step, index) => (
                                <div key={`step-review-${step.StepTitle}`} className="review-step">
                                    <div className="review-step-nav-item basis-1/3">
                                        <h3>
                                            {step.StepTitle}
                                        </h3>
                                        <Link
                                            to={{
                                                // pathname: step.getPath()
                                                pathname: step.getPath(!isAdminEditing ? '/talent/application' : '..')
                                            }}
                                            state={{fromReview: true}}
                                            className="btn btn-link justify-start">

                                            {`${TB.trans('talent.review.edit_link_txt')} ${step.StepTitle}`}

                                        </Link>
                                    </div>

                                    <div className="review-display basis-2/3">
                                        {this.reviewStep(step)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        );
    }


}